import React from 'react';
import ReactDOM from 'react-dom';
import { LocaleProvider } from 'antd';
import { connect } from 'dva';
import BaseComponent from '../../../components/BaseComponent';
import LoadAd from './LoadAd';

//import ServiceSelector from '../components/ServiceSelector';
//import CitySelector from '../components/CitySelector';

class AdPage extends BaseComponent {

//  ReactDOM.render(<ServiceSelector store={props.app._store}/>, document.querySelector('#package-selector'));
//  ReactDOM.render(<CitySelector store={props.app._store}/>, document.querySelector('#city-selector'));
//  debugger;
  componentWillMount() {
    const {app, meta} = this.props;
    console.info(this.props);

    const ads = document.querySelectorAll(".ad");
    console.info('[NOI]', ads.length);

    if(ads){
      for (let i = 0; i < ads.length; ++i) {
//        console.info(ad.dataset);
        ReactDOM.render(<LoadAd store={app._store} appKey={this.props.appKey} {...ads[i].dataset} />, ads[i]);
      }
    }

  }
  render() {
    return (
      <div></div>
    )
  }
};
//export default ToolPage;
export default connect(({ ad }) => ({
  ad
}))(AdPage);

//



// WEBPACK FOOTER //
// ./src/pages/ad/components/AdPage.js